<template>
  <div class="flex h-[calc(100vh-7rem)] bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
    <!-- 左侧会话列表 -->
    <ConversationList />

    <!-- 中间聊天区域 -->
    <ChatArea v-if="chatStore.currentConversationId" />

    <!-- 空状态 -->
    <div v-else class="flex-1 flex items-center justify-center bg-slate-50/50">
      <div class="text-center">
        <div class="w-20 h-20 mx-auto mb-4 rounded-full bg-slate-100 flex items-center justify-center">
          <svg class="w-10 h-10 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/>
          </svg>
        </div>
        <p class="text-slate-500 text-sm">选择一个会话开始聊天</p>
        <p class="text-slate-400 text-xs mt-1">从左侧列表中选择联系人或群组</p>
      </div>
    </div>

    <!-- 右侧信息面板 -->
    <transition name="slide-right">
      <ChatInfoPanel v-if="chatStore.showInfoPanel && chatStore.currentConversation" />
    </transition>

    <!-- 新建会话弹窗 -->
    <NewConversationDialog />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useChatStore } from '@/stores/chat'
import ConversationList from './components/ConversationList.vue'
import ChatArea from './components/ChatArea.vue'
import ChatInfoPanel from './components/ChatInfoPanel.vue'
import NewConversationDialog from './components/NewConversationDialog.vue'

const chatStore = useChatStore()

onMounted(() => {
  chatStore.loadConversations()
  chatStore.loadContacts()
})
</script>

<style scoped>
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.25s ease;
}
.slide-right-enter-from,
.slide-right-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
</style>
